import React, { useContext } from "react";
import { useVoucherTerms } from "@queries/useVoucherTerms";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const VoucherTerms = () => {
    const { subscriberGroupId } = useContext(ApplicationContext);
    const { voucherTerms, isLoading } = useVoucherTerms(subscriberGroupId);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    return (
        <div className="voucher-terms__wrapper admin-content">
            {voucherTerms ? (
                // eslint-disable-next-line react/no-danger
                <div className="voucher-terms__content" dangerouslySetInnerHTML={{ __html: voucherTerms }} />
            ) : (
                <p className="paragraph">Voucher terms content to follow</p>
            )}
        </div>
    );
};

export default VoucherTerms;
